import StatusLabel from 'components/StatusLabel/StatusLabel';
import { StdListCell, StdListRow } from 'components/StdList';
import Immutable from 'immutable';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { CreateRFI } from 'records/interactions/CreateRFI';
import { RFI } from 'records/RFI';
import { getShortDateStr } from 'utils/format';
import { clearQueryParam } from 'utils/url';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps, RouteComponentProps {
  rfi: RFI;
  openItemId: string;
}

const RFIRow = (props: Props) => {
  const handleRFIRowClick = (): void => {
    const { rfi } = props;

    if (rfi.number === -1) {
      draftRowClick();
    } else {
      rfiRowClick(rfi);
    }
  };

  const rfiRowClick = (rfi: RFI): void => {
    const { appState, history, location } = props;

    if (!appState.interactions.some((i) => i.type === 'CreateRFI')) {
      const nextLocation = {
        ...location,
        search: `?rfi=${encodeURIComponent(rfi.id)}`,
      };

      history.replace(nextLocation);
    }
  };

  const draftRowClick = (): void => {
    const { appState, actions, rfi, history } = props;

    clearQueryParam('rfi', history);

    const interaction = new CreateRFI({
      rfi: rfi.toNewRFI(),
      fromDraft: true,
      rfiid: rfi.id,
      attachments: rfi.attachments,
    });

    const currentlyOpenRFIInteraction = appState.interactions.find(
      (i) => i.type === 'ViewRFI' || i.type === 'CreateRFI'
    );

    if (currentlyOpenRFIInteraction) {
      actions.updateInteraction(interaction);
    } else {
      actions.createInteraction(interaction);
    }
  };

  const { rfi, openItemId } = props;

  const isDraft = rfi.craeteddate === 0;
  let status = 'Open';
  if (rfi.answer) {
    status = 'Closed';
  } else if (isDraft) {
    status = 'Draft';
  }

  let assignees = 'None';

  if (Immutable.isList(rfi.assignees) && rfi.assignees.size > 0) {
    assignees = rfi.assignees.map((user) => user.email).join(', ');
  }

  const selected = openItemId && openItemId === rfi.id;

  const rowId = `rfi-list-row-${rfi.id}`;
  const rfiVersionNumber = `${rfi.number} ${
    rfi.versionnumber ? `.${rfi.versionnumber}` : ''
  }`;

  return (
    <StdListRow
      id={rowId}
      onClick={handleRFIRowClick}
      selected={!!selected}
      style={{ backgroundColor: '#fff' }}
    >
      <StdListCell id={`${rowId}-cell-number`}>
        <div className="pl3">{rfiVersionNumber}</div>
      </StdListCell>
      <StdListCell id={`${rowId}-cell-title`}>{rfi.title}</StdListCell>
      <StdListCell id={`${rowId}-cell-answer`} truncate={false}>
        <StatusLabel status={status} />
      </StdListCell>
      <StdListCell id={`${rowId}-cell-assignees`}>{assignees}</StdListCell>
      <StdListCell id={`${rowId}-cell-createddate`}>
        {getShortDateStr(rfi.craeteddate, 'No Created Date')}
      </StdListCell>
      <StdListCell id={`${rowId}-cell-duedate`}>
        {getShortDateStr(rfi.duedate, 'No Due Date')}
      </StdListCell>
    </StdListRow>
  );
};

export default withRouter(withAppStore<Props>(RFIRow));
